<template>
  <section>
    <KpiCards
      class="mb-3"
      :items="kpiItems"
      :loading="loadingSummary"
      :skeleton="4"
    />

    <data-table
      :headers="headers"
      :items="customers"
      commit="SET_CUSTOMER"
      :viewItem="viewItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("customer") }}
          </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 offset-lg-7">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
      </div>
    </data-table>

    <app-custom-dialog v-model="dialog" :footer="false" title="description">
      <div slot="activator">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-subtitle-1 font-weight-medium">
              {{ form.first_name }} {{ form.last_name }}
            </div>
            <div class="text-body-2 grey--text">{{ form.phone_no || "-" }}</div>
          </v-col>
          <v-col cols="12" class="pt-0"><v-divider /></v-col>

          <v-col cols="4" class="grey--text">{{ $t("id") }}</v-col>
          <v-col cols="8" class="text-right font-weight-medium">{{
            form.id
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("point") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.point || 0) | NumberFormat
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("tickets_count") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.history_buy_count || 0) | NumberFormat
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("total_paid") }}</v-col>
          <v-col cols="8" class="text-right">{{
            (form.history_buy_sum_total_paid || 0) | NumberFormat
          }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("address") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.address || "-" }}</v-col>
          <v-col cols="4" class="grey--text">{{ $t("date") }}</v-col>
          <v-col cols="8" class="text-right">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>

    <app-loading :overlay="overlay" />
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { myMixin } from "@/mixin/main";
import { adminStoreSummary } from "@/mixin/adminStoreSummary";

export default {
  mixins: [myMixin, adminStoreSummary],
  components: { DataTable },
  data: () => ({
    overlay: false,
    search: "",
    dialog: false,
    form: {},
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummary("customers")]);
  },
  computed: {
    ...mapGetters({
      customers: "index/customers",
    }),
    headers() {
      return [
        { text: this.$t("id"), value: "index" },
        { text: this.$t("customer_name"), value: "first_name" },
        { text: this.$t("last_name"), value: "last_name" },
        { text: this.$t("phon_no"), value: "phone_no" },
        { text: this.$t("point"), value: "point" },
        { text: this.$t("tickets_count"), value: "history_buy_count" },
        { text: this.$t("total_paid"), value: "history_buy_sum_total_paid" },
        { text: this.$t("date"), value: "created_at", align: "right" },
        { text: this.$t("manage"), value: "actions", align: "right" },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const { store_id } = this.$route.params;
      const body = {
        that: this,
        url: `get_shop_customers/${store_id}?q=${encodeURIComponent(this.search || "")}`,
        commit: "SET_CUSTOMER",
      };
      await this.fetch(body);
    },
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
